import BsModal from 'react-bootstrap/Modal'
import React from 'react'
import Button from 'react-bootstrap/Button'
import PropTypes from 'prop-types'
import Form from './shared/Form'
import ErrorBoundary from './shared/ErrorBoundary'
import withLocale from '~/hocs/locale'
import { ModalType } from '~/hooks/useModalForm'

const FormModal = ({
  modelName,
  modalType,
  show,
  children,
  onClose,
  submitLabel,
  submittingLabel,
  size,
  closeLabel,
  title,
  createLabel,
  editLabel,
  deleteLabel,
  viewLabel,
  searchLabel,
  footerChildren,
  ...props
}) => {
  ModalType.getLabel = (modalState) => {
    switch (modalState) {
      case ModalType.CREATE:
        return createLabel
      case ModalType.DELETE:
        return deleteLabel
      case ModalType.EDIT:
        return editLabel
      case ModalType.VIEW:
        return viewLabel
      case ModalType.SEARCH:
        return searchLabel
      default: return ''
    }
  }

  const customTitle = title ?? ModalType.getLabel(modalType)
  const fullTitle = modelName ? `${customTitle} ${modelName}` : customTitle

  return (
    <BsModal show={show} size={size} onHide={onClose}>
      <ErrorBoundary onClose={onClose} className="mb-0">
        <Form {...props}>
          {(formikProps) => (
            <>
              <BsModal.Header>
                <BsModal.Title>{fullTitle}</BsModal.Title>
              </BsModal.Header>
              <BsModal.Body>
                {children instanceof Function ? children(formikProps) : children}
              </BsModal.Body>
              <BsModal.Footer className="flex justify-content-between">
                <div>
                  {footerChildren}
                </div>
                <div>
                  {onClose && (
                    <Button variant="link" onClick={onClose}>
                      {closeLabel}
                    </Button>
                  )}
                  {
                  modalType !== ModalType.VIEW &&
                  <Form.Submit text={submitLabel} submittingText={submittingLabel} />
                  }
                </div>
              </BsModal.Footer>
            </>
          )}
        </Form>
      </ErrorBoundary>
    </BsModal>
  )
}

FormModal.propTypes = {
  title: PropTypes.string,
  modelName: PropTypes.string,
  modalType: PropTypes.string,
  show: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func
  ]).isRequired,
  onClose: PropTypes.func,
  submitLabel: PropTypes.string.isRequired,
  submittingLabel: PropTypes.string.isRequired,
  closeLabel: PropTypes.string,
  size: PropTypes.string,
  createLabel: PropTypes.string,
  editLabel: PropTypes.string,
  deleteLabel: PropTypes.string,
  viewLabel: PropTypes.string,
  searchLabel: PropTypes.string,
  buttonChildren: PropTypes.element
}

FormModal.defaultProps = {
  show: false,
  title: undefined,
  modelName: undefined,
  onClose: null,
  closeLabel: 'Close',
  size: 'md',
  createLabel: 'Create',
  editLabel: 'Edit',
  deleteLabel: 'Delete',
  viewLabel: 'View',
  searchLabel: 'Search',
  modalType: '',
  buttonChildren: undefined
}

const Modal = {
  Form: withLocale('common', 'formModal')(FormModal),
  SearchForm: withLocale('common', 'searchModal')(FormModal),
}

export default Modal
